module.exports = __webpack_public_path__ + "img/made-reagent.9dcdb3f5.svg";